/*
 * Copyright (c) 2011-2018, Zingaya, Inc. All rights reserved.
 */

'use strict';
import 'eventsource-polyfill';

var _eventSource = null;

export default class ConnectionManager {
    static myInstance = null;
    _isConnected = false;
    _eventSource = null;
    mIsWaitingConnect = false;
    mUrlConnect = "";

    constructor() {
      
    }

    static getInstance() {
        console.log("ConnectionManager getInstance...")
        if (this.myInstance === null) {
            this.myInstance = new ConnectionManager();
        }
        return this.myInstance;
    }

    //hàm thực hiện kết nối lên server deepcare nhận event
    _connectServer(url) {
        console.log("ConnectionManager connectServer...url: " + url + " isConnected: " + this._isConnected
        + " mIsWaitingConnect: " + this.mIsWaitingConnect)
        //kiểm tra nếu đang chờ connect hoặc đã connect thì sẽ ko gửi connect nữa
        if(this.mIsWaitingConnect || this._isConnected) {
            return;
        }
        
        this.mIsWaitingConnect = true;
        this.mUrlConnect = url;

        this._eventSource = new EventSource(url);
        console.log("ConnectionManager connectServer do connecting...")
        this._eventSource.addEventListener("userConnect", (event) => {
            this._isConnected = true;
            this.mIsWaitingConnect = false;
            console.log("ConnectionManager connectServer userConnect...event: " + JSON.stringify(event));
        });
        
    }

    //Hàm trả về connection để thực hiện lắng nghe xự kiện
    getEventSource () {
        return this._eventSource;
    }

    //hàm kiểm tra xem trạng thái có đang connect hay không
    isConnected() {
        return this._isConnected;
    }

    //hàm xử lí trả về url connect
    getUrlConnect() {
        return this.mUrlConnect;
    }

    //hàm đóng connect lên server
    _closeConnect() {
        console.log("ConnectionManager _closeConnect...");
        if(this._eventSource !== null) {
            this._eventSource.close();
        }
    }

    //hàm xử lí clear hết tất cả listener
    _removeAllListeners() {
        console.log("ConnectionManager _closeConnect...");
        if(this._eventSource !== null) {
            this._eventSource.removeAllListeners();
        }
    }

}